import React, { useState } from 'react'
import { colorAptitude } from '../../../helpers/helpers'
import { useKeyByWord } from '../../../customHooks/useKyByWord'
import { EntryOrDepartureDetail } from './EntryOrDepartureDetail'
import { t } from 'i18next'
import { ResourceDetail } from './ResourceDetail'
import useWindowSize from '../../../customHooks/useWindowSize'

export const EntryAndDepartureDetail = ({ showDetailModal, setShowDetailModal, resourceInfo }) => {
    const { windowWidth } = useWindowSize();
    const putFlexWrap = windowWidth <= 650 ? 'flex-wrap' : '';
    const putMobileView = windowWidth <= 650;
    const visitTypes = ['VIS', 'VEHVIS'];
    const translationHook = useKeyByWord;
    const translationApt = (typeKey, key) => translationHook(typeKey, key);
    const [edited, setEdited] = useState(false)

    return (
        <>
            <div className='d-flex justify-content-between align-items-center pb-2'>
                <div className='d-flex align-items-center'>
                    <i
                        type='button'
                        style={{ color: 'var(--gray-600)' }}
                        className="ms-1 fa-solid fa-arrow-left"
                        onClick={() => setShowDetailModal(!showDetailModal)}
                    >
                    </i>

                    <p className='m-0 ms-2' style={{ fontSize: '20px', fontWeight: '500' }}>{useKeyByWord('resource_detail', resourceInfo.resource_type)}</p>

                    {!visitTypes.includes(resourceInfo.resource_type) ?
                        <div className={`ms-2 tablet-color ${colorAptitude(resourceInfo.status)}`} style={{ color: 'var(--white)' }}>
                            <p className='m-0 text-center'>{translationApt('aptitude_status', resourceInfo.status)}</p>
                        </div>
                        : null
                    }
                </div>

                {!putMobileView ?
                    < div >
                        <button
                            type="button"
                            className="btn"
                            onClick={() => setShowDetailModal(!showDetailModal)}
                        >
                            <i className="fa-solid fa-xmark"></i>
                        </button>
                    </div>
                    : null
                }


            </div >

            <div className=''>
                <ResourceDetail resourceInfo={resourceInfo} wasEdited={edited} />
            </div>

            <p className='m-3 mb-1' style={{ fontSize: '12px', fontWeight: '600' }}>{t('MOVEMENTS')}</p>

            <div className={`d-flex ${putFlexWrap}`}>

                <div className={`m-3 entryOrDepartureDetailCard`} style={{ backgroundColor: '#ffff', borderRadius: '10px' }}>
                    <EntryOrDepartureDetail
                        type={'ENTRY'}
                        resourceType={resourceInfo.resource_type}
                        setEdited={setEdited}
                    />
                </div>

                <div className={`m-3 entryOrDepartureDetailCard`} style={{ backgroundColor: '#ffff', borderRadius: '10px' }}>
                    <EntryOrDepartureDetail
                        type={'DEPARTURE'}
                        resourceType={resourceInfo.resource_type}
                        setEdited={setEdited}
                    />
                </div>

            </div>
        </>
    )
}
